import React from 'react'
import TaxProfileEditor from './TaxProfileEditor'

function CreateTaxProfile() {
  return (
    <TaxProfileEditor />
  )
}

export default CreateTaxProfile